<template>
  <div class="resource_subject_add_wrap">
    <div class="header">
      <el-button size="medium" @click="goBack">返回</el-button>
      <el-button size="medium" type="primary" @click="saveSuite">保存</el-button>
    </div>
    <div class="resource_subject_box" :style="`height: ${windowHeight - 170}px;`">
      <div class="resource_subject_content">
        <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
          <el-form-item label="名称" prop="name">
            <el-input v-model="formData.name" :minlength="1" :maxlength="20" placeholder="请输入单元名称（1-20个字符）"></el-input>
          </el-form-item>
          <el-form-item label="序号" prop="orderNo">
            <el-input-number v-model="formData.orderNo" controls-position="right" :min="1" :max="10000"></el-input-number>
          </el-form-item>
          <el-form-item label="说明" prop="remark">
            <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="formData.remark">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize'
  import {getGradeAtlasDetailInfoById, addAtlasDetail, editAtlasDetail} from '@/api/resourceMap'

  export default {
    name: "resourceMenuAdd",
    data() {
      return {
        atlasId: sessionStorage.getItem('atlasId'),
        pidAtlasId: this.$route.query.pidAtlasId,
        menuId: this.$route.query.menuId,
        pAtlasJson: {},
        formData: {
          name: '',
          orderNo: 1,
          remark: ''
        },
        rules: {
          name: [
            { required: true, trigger: 'blur', message: '请输入单元名称' },
            { min: 1, max: 20, message: "输入长度在1到20个字符", trigger: "change" }
          ],
          orderNo: [
            { required: true, trigger: 'blur', message: '请选择序号' }
          ]
        }
      }
    },
    mixins: [windowResize],
    created() {
      this.getGradeAtlasDetailInfoById();
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      getGradeAtlasDetailInfoById() {
        getGradeAtlasDetailInfoById({gradeAtlasId: this.pidAtlasId || this.menuId}).then(data => {
          this.pAtlasJson = data;
          if (this.menuId) {
            this.formData = {
              name: data.name,
              orderNo: data.orderNo,
              remark: data.remark
            }
          }
        })
      },
      saveSuite() {
        this.$refs.form.validate(isValid => {
          if (isValid) {
            new Promise(resolve => {
              if (this.menuId) {
                let query = {
                  name: this.formData.name,
                  orderNo: this.formData.orderNo,
                  id: this.menuId,
                  remark: this.formData.remark
                };
                editAtlasDetail(query).then(resolve)
              } else {
                let query = {
                  atlasId: this.pAtlasJson.atlasId,
                  level: this.pAtlasJson.level + 1,
                  name: this.formData.name,
                  orderNo: this.formData.orderNo,
                  pid: this.pAtlasJson.id,
                  remark: this.formData.remark,
                  type: 2
                };
                addAtlasDetail(query).then(resolve)
              }
            }).then(() => {
              this.$message.success(`${this.menuId ? '编辑成功' : '新增成功'}`);
              window.setTimeout(() => {
                this.$emit('change-tree', this.formData.name);
                this.goBack();
              }, 500);
            })
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './../../../styles/mixin';

  .resource_subject_add_wrap {
    padding: 12px;

    .header {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }

    .resource_subject_box {
      @include scrollBar;

      .resource_subject_content {
        width: 810px;
        margin: 0 auto;
        padding-top: 20px;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/study/resourceMap/resourceMenuAdd.vue